import { mount } from 'app/main.jsx';
import 'app/main.css';

Error.stackTraceLimit = 50;

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
} else {
    mount();
}
